
  import { Vue, Component, Emit } from 'vue-property-decorator';
  import { data } from './mc-serve.data';
  import { clone } from '@/utils';
  import { MealCountDto, MealCountCalcs} from '@/models';
  
  @Component
  export default class McServeTests extends Vue {

    viewModel = data.vm;
    mealCountCalc = new MealCountCalcs(this.viewModel.mealCounts);

    created() {
    }

    mounted() {
      this.$store.state.auth.user = data.user;
    }

    inputChanged() {

    }
  }
